import React from 'react';
import { styled } from '@linaria/react';
import { SandpackCodeEditor } from '@codesandbox/sandpack-react';

import CodeEditorContext from './CodeEditorContext';

function CodeEditor() {
  const { codeMirrorGrabberRef, editorWrapperRef, showLineNumbers } =
    React.useContext(CodeEditorContext);

  return (
    <Wrapper ref={editorWrapperRef} translate="no">
      <SandpackCodeEditor
        ref={codeMirrorGrabberRef}
        wrapContent
        showLineNumbers={showLineNumbers}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: 0px;
  padding-bottom: 8px;
  height: 100%;
  font-size: 0.875rem;
`;

export default CodeEditor;
